var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,13.2c-2.1,0.6-3.4,2.2-3.4,3.7s1.3,3.1,3.4,3.7C20.8,20.6,20.8,13.2,20.8,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.2,24.4v7.4c2.1-0.6,3.4-2.2,3.4-3.7S26.3,25,24.2,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45,22.5C45,34.9,34.9,45,22.5,45S0,34.9,0,22.5S10.1,0,22.5,0S45,10.1,45,22.5z M22.5,7.3 c0.9,0,1.7,0.8,1.7,1.7v0.7c3.7,0.7,6.8,3.4,6.8,7.2c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7c0-1.5-1.3-3.1-3.4-3.7V21 c3.7,0.7,6.8,3.4,6.8,7.2s-3.1,6.5-6.8,7.2V36c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7v-0.7c-3.7-0.7-6.8-3.4-6.8-7.2 c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7c0,1.5,1.3,3.1,3.4,3.7V24c-3.7-0.7-6.8-3.4-6.8-7.2s3.1-6.5,6.8-7.2V9 C20.8,8.1,21.6,7.3,22.5,7.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.cfb05eceb07f44c2df5baf4d8d1cb68f.svg";
export { ForwardRef as ReactComponent };